import api from "../api.js";

/**
 * Order service
 *
 * Wraps the HOPS Fulfilment Order APIs.
 *
 * @package HOPS
 * @subpackage Services
 * @copyright Heritage Operations Processing Limited
 */
class FulfilmentService {

	/**
	 * Get orders - all unfulfilled, and fulfilled by this device in the last day (since midnight)
	 *
	 * @param {Integer} OrderId
	 * @return {Promise} Resolves with the API's response data
	 */
	static getOrders() {
		return api.call({url: `/api/fulfilment/orders`}).then(({data}) => data);
	}


	/**
	 * Change the fulfilment status of an order
	 *
	 * @param {Integer} OrderId
	 * @param {boolean} Fulfilled
	 * @return {Promise} Resolves with the API's response data
	 */
	static updateOrder(OrderId, Fulfilled) {
		return api.call({
			url: `/api/fulfilment/orders/${OrderId}`,
			method: "POST",
			data: {
				Fulfilled
			}
		}).then(({data}) => data);
	}
}

export default FulfilmentService;
